<template>
<!-- 基础用法：图标 + 文字 -->
 <div class="loading-container" :style="{ height: height }">
    <div class="custom-spinner"></div>    
  </div>
</template>

<script>


export default {
    name: 'LoadingBar',
    props: {
        height: {
            type: String,
            default: '200px'
        },
    },
    components: {
        
    }
}
</script>

<style scoped>
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center; 
  width: 100%;
  color: #2d8cf0; /* 主色调 */
}

/* 核心转圈动画 */
.custom-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #f3f3f3;      /* 浅色背景 */
  border-top: 3px solid #2d8cf0;   /* 高亮颜色 */
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin-bottom: 16px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
